import { Subject, distinct, interval, bufferTime, filter, map, firstValueFrom } from 'rxjs';

const serverPushEventContainerTitle = "server-push-data.event";
const _ServerPushConsumer = class _ServerPushConsumer {
  constructor() {
    /**
     * ui 컴포넌트로부터 수신한 연결 해지 신호 스트림
     * 연결 해지 신호를 서비스 워커로 전달한 후 완료 신호를 발행
     */
    this._disconnectSubject = new Subject();
    this._disconnectedSubject = new Subject();
    /**
     * Subject<ServerPushEventContainer>
     */
    this._serverPushEventContainerSubject = new Subject();
    /**
     * ui 컴포넌트로부터 수신한 토픽 구독 신호 스트림의 버퍼 처리
     */
    this._topicStringSubject = new Subject();
    if (!("serviceWorker" in navigator)) {
      return;
    }
    navigator.serviceWorker.register(
      "/static-bundles/service-worker/index.min.js",
      { scope: _ServerPushConsumer._scope }
    );
    navigator.serviceWorker.addEventListener(
      "message",
      (event) => {
        const { data: eventData } = event;
        if ("title" in eventData && eventData.title === serverPushEventContainerTitle) {
          this._serverPushEventContainerSubject.next(
            eventData
          );
        }
      }
    );
    this._topicStringSubject.pipe(
      /**
       * 전송 주기마다 중복된 토픽을 제거
       */
      distinct(void 0, interval(_ServerPushConsumer.interval)),
      /**
       * 전송 주기마다 버퍼 처리
       */
      bufferTime(_ServerPushConsumer.interval),
      /**
       * 수신한 토픽이 없으면 무시
       */
      filter((topics) => topics.length > 0)
    ).subscribe(async (topics) => {
      const registration = await navigator.serviceWorker.getRegistration(
        _ServerPushConsumer._scope
      );
      registration?.active?.postMessage({
        payload: { topics },
        title: "server-push-consume.command"
      });
    });
    this._disconnectSubject.pipe(
      /**
       * 전송 주기마다 중복된 요청을 제거
       */
      distinct(void 0, interval(_ServerPushConsumer.interval))
    ).subscribe(async () => {
      const registration = await navigator.serviceWorker.getRegistration(
        _ServerPushConsumer._scope
      );
      registration?.active?.postMessage({
        payload: null,
        title: "connect-server-push.disconnect.command"
      });
      this._disconnectedSubject.next();
    });
  }
  static get interval() {
    return _ServerPushConsumer._interval;
  }
  /**
   * ui 컴포넌트가 구독하고자 하는 토픽을 수신하여 서비스 워커로 전달하기 전 별도 버퍼에 쌓기
   * @param topicString - 구독하고자 하는 토픽
   */
  concernTopic(topicString) {
    this._topicStringSubject.next(topicString);
  }
  /**
   * 서비스 워커에서 수신한 server-push 이벤트를 구독
   * @param topicString - 구독하고자 하는 토픽
   * @returns - server-push 이벤트 스트림
   */
  createServerPushEvent$(topicString) {
    const serverPushEventContainerSubject = this._serverPushEventContainerSubject;
    const isTServerPushEventContainer = (serverPushEventContainer) => serverPushEventContainer.payload.topic === topicString;
    return serverPushEventContainerSubject.pipe(
      filter(isTServerPushEventContainer),
      map(({ payload: { serverPushEvent } }) => serverPushEvent)
    );
  }
  /**
   * ui 컴포넌트로부터 수신한 연결 해지 신호를
   * 서비스 워커로 전달하기 전 별도 버퍼에 쌓기
   */
  disconnect() {
    this._disconnectSubject.next();
    return firstValueFrom(this._disconnectedSubject);
  }
};
/**
 * 토픽을 전송하는 주기
 */
_ServerPushConsumer._interval = 2e3;
/**
 * server-push 이벤트를 처리할 서비스 워커의 스코프
 */
_ServerPushConsumer._scope = "/";
let ServerPushConsumer = _ServerPushConsumer;

export { ServerPushConsumer };
//# sourceMappingURL=server-push-consumer.mjs.map
